import { useCallback, useEffect, useState } from 'react';
import { getStoredToken, setStoredToken, removeStoredToken } from '../../services/apiClient';

export function useAuthToken() {
  const [token, setTokenState] = useState<string | null>(() => getStoredToken() || null);

  const setToken = useCallback((next: string | null) => {
    if (typeof window === 'undefined') return;
    if (next) {
      setStoredToken(next);
    } else {
      removeStoredToken();
    }
    setTokenState(next);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const storageHandler = () => setTokenState(getStoredToken() || null);
    const eventHandler = (ev: Event) => {
      const custom = ev as CustomEvent<string | null>;
      setTokenState(custom.detail ?? null);
    };
    window.addEventListener('storage', storageHandler);
    window.addEventListener('sj:token', eventHandler as EventListener);
    return () => {
      window.removeEventListener('storage', storageHandler);
      window.removeEventListener('sj:token', eventHandler as EventListener);
    };
  }, []);

  return {
    token,
    setToken,
  };
}

